import { render } from "./groupmanage.vue?vue&type=template&id=5b781c28&scoped=true"
import script from "./groupmanage.vue?vue&type=script&lang=js"
export * from "./groupmanage.vue?vue&type=script&lang=js"

import "./groupmanage.vue?vue&type=style&index=0&id=5b781c28&scoped=true&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b781c28"]])

export default __exports__